<template>
  <div>
    <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom" :title="$t(`core.${action}_files`)"
      :default-cancel="false" :width="750" @close="closeDialog">
      <div class="tc-panel">
        <div class="tc-panel-hd mb-0">
          <div class="col">
            <h3 class="title">
              {{$t('core.params_be_pasted',{num:pasteFilesCount})}} {{$t('core.conflict_paste')}}
            </h3>
          </div>
        </div>
        <div class="tc-panel-bd">
          <qc-table-client-pagination :list="sameNameList" min-height="30px" max-height="250px" :page-size="1000">
            <qc-table-column :label="$t('core.original_name')" field="name">
              <template slot-scope="{ item }">
                <div :title="item.name" class="custom-text-overflow">{{item.isDir? `${item.name}/`: item.name}}</div>
              </template>
            </qc-table-column>
            <qc-table-column :label="$t(`core.${type==='rename'?type:'mtime'}`)" :width="type==='rename'?400:200">
              <template slot-scope="{ item }">
                <div v-if="type==='rename'" :class="{'is-error':item.exist}">
                  <qc-input :placeholder="$t('core.rename')" v-model="item.rename" @input="convertExist(item)"
                    style="width:100%"></qc-input>
                </div>
                <div v-else>
                  {{item.mtime}}
                </div>
              </template>
            </qc-table-column>

            <template slot="pagination" slot-scope="page">
              <qc-pagination v-if="page.totalNum > 1000" :total-num="page.totalNum" :page-size.sync="page.pageSize"
                :curr-page.sync="page.currPage" :min-page-size="1000" :max-page-size="1000" :page-size-step="1000">
              </qc-pagination>
              <!-- 为了避免插槽 fallback 回默认分页器，以下一行代码不可删除 -->
              <span style="display: none;"></span>
            </template>
          </qc-table-client-pagination>
        </div>
      </div>

      <ul class="form-list mt-10">
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t('core.action')}}</label>
          </div>
          <div class="form-input">
            <div class="form-unit">
              <qc-radio value="replace" v-model="type" class="mr-10">{{$t("core.replace")}}</qc-radio>
              <qc-radio value="skip" v-model="type" class="mr-10">{{$t("core.skip")}}</qc-radio>
              <qc-radio value="rename" v-model="type">{{$t("core.rename")}}</qc-radio>
            </div>
          </div>
        </li>
      </ul>

      <div slot="button">
        <div class="justify-grid">
          <div class="col"></div>
          <div class="col">
            <qc-button type="default" @click="onSubmit" :title="$t(`core.${type}`)">{{$t(`core.${type}`)}}</qc-button>
            <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
          </div>
        </div>
      </div>

    </qc-dialog>
  </div>
</template>

<script>
import {
  tips, getInnerProps, formatTime, path,
} from '@/scripts/tools/utils';
import eventProxy from '@/scripts/tools/eventProxy';
import copyer from '@/scripts/helper/copyer';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      source: {},
      target: {},
      action: 'copy',
      type: 'replace',
      sameNameList: [],
      sameNameMap: {},
      secondSameNameList: [], // 重命名后再次重名的文件列表
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    isInSameFolder() {
      const { source, target } = this;
      return (
        source.Bucket === target.Bucket
        && source.Region === target.Region
        && source.Prefix === target.Prefix
      );
    },
    pasteFilesCount() {
      let count = 0;
      const { files } = this.source;
      if (files) {
        count = files.length;
      }
      return count;
    },
  },
  mounted() {
    eventProxy.on('show.pasteFiles', this.initData);
  },
  destroyed() {
    eventProxy.off('show.pasteFiles', this.initData);
  },
  methods: {
    initData({
      source, target, action, sameNameList,
    }) {
      this.source = source;
      this.target = target;
      this.action = action;
      this.sameNameList = sameNameList
        .map(item => {
          let rename = '';
          const time = formatTime(Date.now(), 'YYYYMMDD_HHmmss');
          if (item.isDir) {
            rename = `${item.name}_${time}/`;
          } else {
            const ext = path.extname(item.name);
            const basename = path.basename(item.name, ext);
            rename = `${basename}_${time}${ext}`;
          }
          this.sameNameMap[item.key] = true;
          return { ...item, rename, exist: false };
        })
        .sort((a, b) => {
          let com = 0;
          if (a.isDir !== b.isDir) {
            com = a.isDir ? -1 : 1;
          } else {
            com = a.name > b.name ? 1 : -1;
          }
          return com;
        });

      this.type = 'replace';
      this.secondSameNameList = [];
      this.innerShow = true;
    },
    convertExist(item) {
      item.exist && (item.exist = false);
    },
    async checkIfExistSameName() {
      let exist = false;
      const { source, target, sameNameList } = this;
      const files = sameNameList.map(item => ({
        ...item,
        key: source.Prefix + item.rename,
      }));
      const res = await copyer.getSameNameList({ ...source, files }, target);
      const secondSameNameList = res.sameNameList;
      if (secondSameNameList.length) {
        exist = true;
        const existMap = {};
        [...secondSameNameList, ...sameNameList].forEach(item => {
          !existMap[item.name] && (existMap[item.name] = 0);
          existMap[item.name]++;
          if (existMap[item.name] > 1) {
            item.exist = true;
          } else {
            item.exist = false;
          }
        });
      }
      return exist;
    },
    async onSubmit() {
      const { target, action } = this;
      if (this.type === 'rename') {
        const fileNameMap = {};
        this.sameNameList.forEach(item => {
          if (item.isDir && item.rename.lastIndexOf('/') === -1) {
            item.rename += '/';
          }
          fileNameMap[item.key] = item.rename;
        });
        target.fileNameMap = fileNameMap;

        // 重命名操作需二次检查是否存在同名文件
        const exist = await this.checkIfExistSameName();
        if (exist) {
          tips.error(this.$t('error.exist_same_filename_in_target_location'));
          return;
        }
      } else if (this.type === 'skip') {
        const source = copyer.clipboard;
        const filterFiles = source.files.filter(
          file => !this.sameNameMap[file.key],
        );
        if (!filterFiles.length) {
          tips.error(this.$t('error.no_file_to_paste'));
          this.closeDialog();
          return;
        }
        source.files = filterFiles;
      }

      this.$emit('submit', { target, action });
      this.closeDialog();
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>
